import { createContext, useContext, useMemo } from 'react'
import type { PropsWithChildren } from 'react'

type MailingListLocaleResult = {
	id: string
	[key: string]: any
}

type MailingListContextType = {
	mailingLists: Array<MailingListLocaleResult> | undefined
}

const MailingListContext = createContext<MailingListContextType>({
	mailingLists: [],
})

type MailingListProviderProps = {
	mailingLists?: MailingListLocaleResult[]
}

export const MailingListProvider = (props: PropsWithChildren<MailingListProviderProps>) => {
	const { mailingLists, children } = props
	const value = useMemo(() => ({ mailingLists }), [mailingLists])
	return <MailingListContext.Provider value={value}>{children}</MailingListContext.Provider>
}

export function useMailingList(id: string): MailingListLocaleResult | undefined {
	const { mailingLists } = useContext(MailingListContext)
	return useMemo(() => mailingLists?.find((item) => item.id === id), [mailingLists, id])
}
